import { type HTMLAttributes, type ReactNode, forwardRef } from 'react';

export type PanelVariant = 'default' | 'elevated' | 'bordered';

export interface PanelProps extends HTMLAttributes<HTMLDivElement> {
  variant?: PanelVariant;
  padding?: 'none' | 'sm' | 'md' | 'lg';
  children: ReactNode;
}

export const Panel = forwardRef<HTMLDivElement, PanelProps>(
  ({ variant = 'default', padding = 'md', className = '', children, ...props }, ref) => {
    const baseClass = 'pyxl-panel';
    const classes = [
      baseClass,
      `${baseClass}--${variant}`,
      `${baseClass}--padding-${padding}`,
      className,
    ].filter(Boolean).join(' ');

    return (
      <div ref={ref} className={classes} {...props}>
        {children}
      </div>
    );
  }
);

Panel.displayName = 'Panel';
